export default __webpack_public_path__ + "static/media/story_otomo-2.365b489a.png";